import { createAction, createNetworkActions } from "~/utils/actions";

export default {
	...createNetworkActions("UPDATE_BENEFICIARIES"),
	...createNetworkActions("UPDATE_UTBETALING_START"),
	...createNetworkActions("REGISTER_ONE_TIME_WITHDRAWAL"),
	...createNetworkActions("POLICIES"),
	...createNetworkActions("POLICY_DETAILS"),
	...createNetworkActions("NJORD_POLICY_DETAILS"),
	...createNetworkActions("AGGREGATED_POLICY"),
	...createNetworkActions("UPDATE_SAVING_AMOUNT"),
	...createNetworkActions("UPDATE_KAPITALFORVALTER"),
	...createNetworkActions("UPDATE_NEDTRAPPING"),
	...createNetworkActions("UPDATE_FORVALTNING"),
	...createNetworkActions("SALARY_HISTORY"),
	...createNetworkActions("UPDATE_PAYMENT_DEAL"),
	...createNetworkActions("DELETE_PAYMENT_DEAL"),
	...createNetworkActions("CREATE_PAYMENT_DEAL"),
	...createNetworkActions("HOLDINGS"),
	...createNetworkActions("FICTIVE_UTBETALING_MARKET_VALUE"),
	...createNetworkActions("STOP_SAVINGS"),
	...createNetworkActions("LO_PRODUKTBYTTE"),
	...createNetworkActions("LOAD_IPS_DEPOSIT"),
	...createNetworkActions("DIRECT_PAYMENT"),
	...createAction("RESET_POLICIES"),
};
